/** Escape text for safe HTML embedding. */
export function escapeHtml(s: string): string {
  return String(s)
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');
}

/** Minimal markdown → HTML. Escape first; then headings, lists, bold. */
export function markdownToHtml(markdown: string): string {
  const lines = markdown.replace(/\r\n/g, '\n').split('\n');
  const blocks: string[] = [];
  let listType: 'ul' | 'ol' | null = null;
  let listItems: string[] = [];

  const flushList = () => {
    if (!listType || listItems.length === 0) {
      listType = null;
      listItems = [];
      return;
    }
    const tag = listType;
    blocks.push(`<${tag}>${listItems.map((li) => `<li>${li}</li>`).join('')}</${tag}>`);
    listType = null;
    listItems = [];
  };

  const inline = (raw: string): string => {
    const escaped = escapeHtml(raw);
    return escaped.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
  };

  for (const line of lines) {
    const trimmed = line.trimEnd();
    if (!trimmed.trim()) {
      flushList();
      continue;
    }
    const h2 = trimmed.match(/^##\s+(.+)$/);
    if (h2) {
      flushList();
      blocks.push(`<h2>${inline(h2[1]!)}</h2>`);
      continue;
    }
    const h1 = trimmed.match(/^#\s+(.+)$/);
    if (h1) {
      flushList();
      blocks.push(`<h2>${inline(h1[1]!)}</h2>`);
      continue;
    }
    const ul = trimmed.match(/^[-*]\s+(.+)$/);
    if (ul) {
      if (listType && listType !== 'ul') flushList();
      listType = 'ul';
      listItems.push(inline(ul[1]!));
      continue;
    }
    const ol = trimmed.match(/^\d+\.\s+(.+)$/);
    if (ol) {
      if (listType && listType !== 'ol') flushList();
      listType = 'ol';
      listItems.push(inline(ol[1]!));
      continue;
    }
    flushList();
    blocks.push(`<p>${inline(trimmed)}</p>`);
  }
  flushList();
  return blocks.join('\n') || '<p></p>';
}
